// tslint:disable:no-reserved-keywords no-bitwise
/**
 * Team
 */
export var Team;
(function (Team) {
    /**
     * Good
     */
    Team[Team["good"] = 0] = "good";
    /**
     * Bad
     */
    Team[Team["bad"] = 1] = "bad";
})(Team || (Team = {}));
export const enumMapTeam = {
    Good: Team.good,
    Bad: Team.bad,
    good: Team.good,
    bad: Team.bad,
};
//
// Attack
// ------------------------------------------------------------
/**
 * Categories for attack capability.
 */
export var AttackCapability;
(function (AttackCapability) {
    AttackCapability[AttackCapability["DOTA_UNIT_CAP_MELEE_ATTACK"] = 0] = "DOTA_UNIT_CAP_MELEE_ATTACK";
    AttackCapability[AttackCapability["DOTA_UNIT_CAP_RANGED_ATTACK"] = 1] = "DOTA_UNIT_CAP_RANGED_ATTACK";
})(AttackCapability || (AttackCapability = {}));
export var AttackDamageType;
(function (AttackDamageType) {
    AttackDamageType[AttackDamageType["DAMAGE_TYPE_ArmorPhysical"] = 0] = "DAMAGE_TYPE_ArmorPhysical";
})(AttackDamageType || (AttackDamageType = {}));
//
// Attribute
// ------------------------------------------------------------
/**
 * Categories for attribute.
 */
export var Attribute;
(function (Attribute) {
    Attribute[Attribute["strength"] = 0] = "strength";
    Attribute[Attribute["agility"] = 1] = "agility";
    Attribute[Attribute["intelligence"] = 2] = "intelligence";
})(Attribute || (Attribute = {}));
export const enumMapAttribute = {
    DOTA_ATTRIBUTE_STRENGTH: Attribute.strength,
    DOTA_ATTRIBUTE_AGILITY: Attribute.agility,
    DOTA_ATTRIBUTE_INTELLECT: Attribute.intelligence,
};
//
// Movement
// ------------------------------------------------------------
/**
 * Categories for movement capability.
 */
export var MovementCapability;
(function (MovementCapability) {
    MovementCapability[MovementCapability["DOTA_UNIT_CAP_MOVE_NONE"] = 0] = "DOTA_UNIT_CAP_MOVE_NONE";
    MovementCapability[MovementCapability["DOTA_UNIT_CAP_MOVE_GROUND"] = 1] = "DOTA_UNIT_CAP_MOVE_GROUND";
    MovementCapability[MovementCapability["DOTA_UNIT_CAP_MOVE_FLY"] = 2] = "DOTA_UNIT_CAP_MOVE_FLY";
})(MovementCapability || (MovementCapability = {}));
//# sourceMappingURL=hero.js.map